/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchTeamsRequest
 */
export interface SearchTeamsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof SearchTeamsRequest
     */
    companyGuids: Array<string>;
}

/**
 * Check if a given object implements the SearchTeamsRequest interface.
 */
export function instanceOfSearchTeamsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyGuids" in value;

    return isInstance;
}

export function SearchTeamsRequestFromJSON(json: any): SearchTeamsRequest {
    return SearchTeamsRequestFromJSONTyped(json, false);
}

export function SearchTeamsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchTeamsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyGuids': json['company_guids'],
    };
}

export function SearchTeamsRequestToJSON(value?: SearchTeamsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_guids': value.companyGuids,
    };
}

